import {
  invoke,
  invokeMethod,
  beforeInvoke,
  invokeSync,
  notifyNative,
  onBasicEvent
} from './invoke';
import { subscribe, webSubscribe, publish, webPublish } from './eventbus';

const MacleJSBridge = {
  invoke,
  invokeSync,
  invokeMethod,
  beforeInvoke,
  notifyNative,
  subscribe,
  webSubscribe,
  publish,
  webPublish,
  onBasicEvent
};

export default MacleJSBridge;

export * from './invoke';
export * from './eventbus';
